import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from './Component/Header';
import Footer from './Component/Footer';
import PageHero from './Component/PageHero';
import carpet from './Component/product/carpet.jpeg';
import hardwood from './Component/product/hardwood.png';
import carpettile from './Component/product/carpettile.png';
import laminate from './Component/product/laminate.png';
import luxuryvinyl from './Component/product/luxuryvinyl.png';
import vinyl from './Component/product/vinyl.png';
import waterproof from './Component/product/waterproof.png';
import naturalstone from './Component/product/naturalstone.png';
import s2 from './Component/s2.png';

const categories = [
  { id: 'carpet', label: 'Carpet', image: carpet },
  { id: 'carpet-tile', label: 'Carpet Tile', image: carpettile },
  { id: 'hardwood', label: 'Hardwood', image: hardwood },
  { id: 'laminate', label: 'Laminate', image: laminate },
  { id: 'luxuryvinyl', label: 'Luxury Vinyl', image: luxuryvinyl },
  { id: 'waterproof_Flooring', label: 'Waterproof', image: waterproof },
  { id: 'vinyl', label: 'Vinyl', image: vinyl },
  { id: 'cork', label: 'Cork', image: naturalstone },
];

function Product() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#f7f8fa] text-slate-900 antialiased">
      <Header />
      <PageHero
        eyebrow="Online catalog"
        title="Shopping for new floors in San Rafael?"
        subtitle="Browse the most extensive local online flooring catalog"
      />

      <section className="pb-10 md:pb-16">
        <div className="mx-auto grid max-w-6xl grid-cols-2 gap-3 px-4 sm:gap-5 md:grid-cols-3 lg:grid-cols-4 lg:px-8">
          {categories.map((cat) => (
            <button
              key={cat.id}
              type="button"
              onClick={() => navigate(`/products/${cat.id}`)}
              className="group overflow-hidden rounded-[1.25rem] border-0 bg-white p-0 text-left shadow-sm ring-1 ring-slate-200/80 transition hover:-translate-y-1 hover:shadow-lg"
            >
              <div className="aspect-square overflow-hidden bg-slate-100">
                <img
                  src={cat.image}
                  alt={cat.label}
                  className="h-full w-full object-cover transition duration-500 group-hover:scale-105"
                />
              </div>
              <p className="px-3 py-3 text-center text-sm font-semibold text-[#0075ca] sm:text-base">
                {cat.label}
              </p>
            </button>
          ))}
        </div>

        <div className="mx-auto mt-10 max-w-6xl px-4 sm:px-6 lg:px-8">
          <a href="/financing" className="block overflow-hidden rounded-[1.75rem]">
            <img src={s2} alt="Financing options" className="w-full object-cover" />
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default Product;
